import CheckRounded from '@mui/icons-material/CheckRounded'
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded'
import { Box, Button, ListItemIcon, ListSubheader, Menu, MenuItem, Typography, styled } from '@mui/material'
import { MouseEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useScreenWidth from '../../hooks/useScreenWidth'

const PopoverStyled = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    maxHeight: 250,
    '&::-webkit-scrollbar': {
      backgroundColor: theme.palette.grey[200],
      borderRadius: '4px',
      width: '8px',
      margin: '8px',
      '&-thumb': {
        backgroundColor: theme.palette.grey[500],
        borderRadius: '4px'
      }
    }
  }
}))

const MenuItemStyled = styled(MenuItem)({
  display: 'flex',
  justifyContent: 'space-between',
  minWidth: 178
})

type AdminContentFilterProps = {
  data: any[]
  handleClick: (options: Record<string, number>) => void
}

function AdminContentFilter({ data, handleClick }: AdminContentFilterProps) {
  const { t } = useTranslation(['global'])
  const [anchorLanOrderBy, setAnchorLanOrderBy] = useState<null | HTMLElement>(null)
  const [options, setOptions] = useState<Record<string, number>>({})
  const [numOptions, setNumOptions] = useState<number>(0)
  const isMobile = useScreenWidth(700)

  const handleClickOption = (input: string) => (event: MouseEvent<HTMLLIElement>) => {
    const value = Number.parseInt(event.currentTarget.getAttribute('data-value') || '0')
    const tmpOptions: Record<string, number> = { ...options }

    if (options[input] !== undefined) {
      if (options[input] === value) {
        setNumOptions(numOptions - 1)
        delete tmpOptions[input]
      } else tmpOptions[input] = value
    } else {
      setNumOptions(numOptions + 1)
      tmpOptions[input] = value
    }

    handleClick(tmpOptions)
    setOptions(tmpOptions)
  }

  const handleClickLanOrderBy = (event: MouseEvent<HTMLElement>) => {
    setAnchorLanOrderBy(event.currentTarget)
  }

  const handleCloseLanOrderBy = () => {
    setAnchorLanOrderBy(null)
  }

  return (
    <Box display="flex" alignItems="center">
      <Button
        aria-controls="filter-by-menu"
        aria-haspopup="true"
        sx={{ color: '#2E3338' }}
        onClick={handleClickLanOrderBy}
        endIcon={<ExpandMoreRounded color="primary" />}
      >
        {isMobile ? (
          t('filter-by')
        ) : (
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {t('filter-by')} {numOptions > 0 && `+${numOptions}`}
          </Typography>
        )}
      </Button>

      <PopoverStyled
        id="filter-by-menu"
        anchorEl={anchorLanOrderBy}
        open={Boolean(anchorLanOrderBy)}
        onClose={handleCloseLanOrderBy}
        onClick={handleCloseLanOrderBy}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        {data.map(currentData => (
          <div key={currentData.code}>
            <ListSubheader disableSticky>{t(`${currentData.code}`)}</ListSubheader>
            {currentData.data.map((menu: any) => (
              <MenuItemStyled key={menu.id} data-value={menu.id} onClick={handleClickOption(`${currentData.column}`)}>
                {t(menu.name)}
                {options[currentData.column] === menu.id && (
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <CheckRounded sx={{ color: '#8DDD55' }} />
                  </ListItemIcon>
                )}
              </MenuItemStyled>
            ))}
          </div>
        ))}
      </PopoverStyled>
    </Box>
  )
}

export default AdminContentFilter
